import React from "react";
import "./Contact.css";
import logo from "../../Assets/Background.jpg";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";

function Contact() {
  return (
    <section className="contact-section">
      {/* Banner */}
      <div className="contact-logo-banner">
        <img
          src={logo}
          alt="UMA Design and Construction Office"
          className="contact-logo-img"
        />
        <div className="banner-overlay"></div>
        <div className="banner-text">
          <h1>Contact Us</h1>
          <p>Turning your vision into reality with design and excellence.</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-container">
        {/* Info Section */}
        <div className="contact-info-side">
          <h2 className="gold-gradient">Get in Touch</h2>
          <p className="contact-lead">
            We’d love to hear from you. Reach out through the details below or
            send us a quick message.
          </p>

          <div className="office-details">
            <div className="contact-row">
              <FaMapMarkerAlt className="contact-icon gold-tint" />
              <div>
                <strong>UMA Design & Construction</strong>
                <br />
                502, 5th Floor, Business Tower,
                <br />
                MG Road, Sector 34,
                <br />
                Gurugram, Haryana, India
              </div>
            </div>

            <div className="contact-row">
              <FaEnvelope className="contact-icon silver-tint" />
              <a href="mailto:hello@umadesign.com">
                hello@umadesign.com
              </a>
            </div>

            <div className="contact-row">
              <FaPhone className="contact-icon gold-tint" />
              <a href="tel:+911234567890">+91 12345 67890</a>
            </div>
          </div>

          {/* Map */}
          <div className="map-container">
            <iframe
              title="UMA Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14013.74386239018!2d77.02704934999999!3d28.46934815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d193ae0efad75%3A0xab38e676159c0d2!2sMG%20Road%2C%20Gurugram!5e0!3m2!1sen!2sin!4v1621832576918!5m2!1sen!2sin"
              width="100%"
              height="220"
              allowFullScreen
              loading="lazy"
              style={{ border: 0 }}
            ></iframe>
          </div>
        </div>

        {/* Contact Form */}
        <div className="contact-form-side">
          <form
            className="contact-form"
            onSubmit={(e) => {
              e.preventDefault();
              alert("Message Sent! ✅");
            }}
          >
            <h3>Send a Message</h3>

            <label className="floating-label">
              <input type="text" required />
              <span>Full Name</span>
            </label>

            <label className="floating-label">
              <input type="email" required />
              <span>Email Address</span>
            </label>

            <label className="floating-label">
              <input type="text" required />
              <span>Subject</span>
            </label>

            <label className="floating-label">
              <textarea rows="5" required></textarea>
              <span>Message</span>
            </label>

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;